import view from './View.js';
import iconSVG from 'url:../../img/icons.svg';

class resultView extends view {
  _parentElement = document.querySelector('.results');
  _errorMessage = `<b>No Recipes Found</b> <br> Try a different search query or check your spelling. 
    <br><br> <span>Available search queries: <br>pizza, pasta </span><a href="https://forkify-api.jonas.io/phrases.html" >and ...</a>
    `;
  _message = '';
  _generateMarkup() {
    return this._data.map(this._generatePreviews).join('');
  }

  _generatePreviews(preview) {
    const id = window.location.hash.slice(1);
    return `
          <li class="preview">
            <a class="preview__link ${
              preview.id === id ? 'preview__link--active' : ''
            }" href="#${preview.id}">
              <figure class="preview__fig">
                <img src="${preview.image}" alt="${preview.title}" />
              </figure>
              <div class="preview__data">
                <h4 class="preview__title">${preview.title}</h4>
                <p class="preview__publisher">${preview.publisher}</p>
                <div class="preview__user-generated ${
                  preview.key ? '' : 'hidden'
                }">
                  <svg>
                    <use href="${iconSVG}#icon-user"></use>
                  </svg>
                </div>
              </div>
            </a>
          </li>`;
  }
}

export default new resultView();
